import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import './skye-feedback-item.css';

class FeedbackItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hover: '',
            loaded: false,
            count: 0
        };

        this.handleMouseOver = this.handleMouseOver.bind(this);
        this.handleMouseOut = this.handleMouseOut.bind(this);
        //this.handleLoading = this.handleLoading.bind(this); - *disabled for now
        this.timeout;
    }
    componentDidMount() {
        this.show();
        //this.handleLoading();
        //this.setState({ count : this.props.multiplier * 85 });
        // const feedbackItem = document.querySelector('.feedback-item__block');
        // if(this.props.multiplier === 0){
        //     feedbackItem.focus(); 
        // }
    }
    /** 
     * @method handleMouseOver - handles the class change when the feedback item is in the active state on mouseover.
     */
    handleMouseOver = (event) => {
        this.setState({ hover: ' feedback-item__block--active' });
    }
    /** 
     * @method handleMouseOut - handles the class change when the feedback item is in the inactive state on mouseout.
     */
    handleMouseOut = (event) => {
        this.setState({ hover: '' });
    }
    /**
     * @method show - changes the loaded state false to true.
     */
    show() {
        this.setState({ loaded: true });
    }
    /** 
     * @method handleLoading - delays the appearance of each feedback item when the page loads. *currently disabled
     */
    // handleLoading = (event, that) => {
    //     this.timeout = setTimeout(() => {
    //         this.show();
    //     },  this.props.multiplier * 60 );
    // }

    render() {

        return (
            <React.Fragment>
                {this.props.testimonial !== '' ?
                    <div className={"feedback-item__block container" + (this.state.hover) + ((this.state.loaded) ? ' is--loaded' : '')} onMouseOver={(event) => this.handleMouseOver(event)} onMouseOut={(event) => this.handleMouseOut(event)} tabIndex="0">
                        <div className="feedback-item__layer"></div>
                        <div className="feedback-item__row row">
                            <div className="feedback-item__abbrev col-md-2">
                                <div className="feedback-item__abbrev__box__wrapper">
                                    <span className="feedback-item__abbrev__box">
                                        <span className="feedback-item__abbrev__bg"><span
                                            className="feedback-item__abbrev__initial" aria-label={"First initial, " + this.props.first_name.substring(0, 1) + "."}><span aria-hidden="true">{this.props.first_name.substring(0, 1)}</span></span></span>
                                    </span>
                                </div>
                            </div>
                            <div className="feedback-item__details col-md-10"       >
                                <span className="feedback-item__course text-bold a3-blue"><span className="feedback-course__label">{ this.props.course_title ? 'Course: ' : ''}</span>{this.props.disableLinks ?
                                    <span className="feedback-item__course__link a3-blue">{ReactHtmlParser(this.props.course_title)}</span>:
                                    <a href={'courses/' + this.props.course_id + '/' + this.props.course_slug} className="feedback-item__course__link a3-blue link-uh">{ReactHtmlParser(this.props.course_title)}</a>}
                                </span>

                                {this.props.certificate_id ?
                                    <span className="feedback-item__certificate">
                                        {this.props.disableLinks ?
                                            <span className="feedback-item__certificate__link a3-blue text-bold">
                                                <i className="feedback-item__certificate__icon fas fa-bookmark a3-blue" aria-hidden="true"></i>{this.props.certificate} </span> :
                                            <a href={'suites/' + this.props.certificate_id + '/' + this.props.certificate_slug} className="feedback-item__certificate__link a3-blue text-bold link-uh">
                                                <i className="feedback-item__certificate__icon fas fa-bookmark a3-blue" aria-hidden="true"></i>{this.props.certificate} </a>}
                                    </span> : ''}

                                <span className="feedback-item__student text-bold">{this.props.first_name} {this.props.last_name.substring(0, 1)}.</span>
                                <span className="feedback-item__text__content">
                                    "{ReactHtmlParser(this.props.testimonial)}"</span>
                            </div>
                        </div>
                    </div>
                    : ''}
            </React.Fragment>
        );
    }
}

export default FeedbackItem;